import { render, staticRenderFns } from "./ResourceEquipmentInfo.vue?vue&type=template&id=68ac38f8"
import script from "./ResourceEquipmentInfo.vue?vue&type=script&lang=js"
export * from "./ResourceEquipmentInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports